import { render } from "./HeroiconsSolidRss.vue?vue&type=template&id=390943af"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidRss.vue"]])

export default __exports__